import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import { isExcelFile } from 'helpers'
import * as fromActions from 'store/actions/externalCourses.action'
import { useTranslationRankmi } from 'helpers/translations.helper'
import UploadFile from 'components/ui/modals/UploadFile'
import { Help } from '../common'

const UploadButton: React.FC = () => {
  const [error, setError] = React.useState<React.ReactNode>(null)

  const { t } = useTranslation()
  const tUpload = useTranslationRankmi({
    prefix: 'administration.externalCourses.list.upload',
  })
  const dispatch = useDispatch()

  const [show, setShow] = useState(false)
  const handleClose = () => {
    setShow(false)
    setError(null)
  }

  const handleShow = () => setShow(true)

  const handleFileUpload = (file: File) => {
    setError(null)
    if (!isExcelFile(file)) {
      setTimeout(() => {
        setError(<>{tUpload('modal.error')}</>)
      }, 500)
      return
    }
    dispatch(fromActions.Actions.uploadFile(file))
    setShow(false)
  }

  return (
    <>
      <Dropdown.Item onClick={handleShow}>{tUpload('label')}</Dropdown.Item>
      <UploadFile
        show={show}
        title={tUpload('modal.title')}
        labels={{
          legend: tUpload('modal.legend'),
          addFile: tUpload('modal.addFile'),
          close: t('commons.buttons.close'),
        }}
        template={{
          link: 'https://rankmi-lms-prod.s3.amazonaws.com/templates/propuesta+de+cursos+y+participantes.xlsx',
          label: tUpload('modal.template'),
        }}
        help={<Help />}
        onClose={() => {
          handleClose()
        }}
        onUpload={handleFileUpload}
        error={error}
      />
    </>
  )
}

export default UploadButton
